import VehicleLayoutCanvas from '@/components/purchase/checkout/seat-selection/modal/canvas/VehicleLayoutCanvas';
import { useSeatSelection } from '@/hooks/useSeatSelection';
import { useSeatSelectionLegs } from '@/hooks/useSeatSelectionLegs';
import { TransText } from '@/i18n/trans/text';
import { Icons, Typography } from '@fleet/webshop-ui';
import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

export const VehicleLayoutContainer = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [canvasReady, setCanvasReady] = useState(false);
  const {
    currentPlaceMap,
    floorPlanIcons,
    selectedReservationId,
    selectedFloorIndex,
    selectedLegId,
    handleSeatSelect,
    handlePassengerSeatClick,
  } = useSeatSelection();
  const { legs } = useSeatSelectionLegs();
  const currentFloor = currentPlaceMap?.floors?.[selectedFloorIndex];
  const selectedLeg = legs.find((leg) => leg.id === selectedLegId);
  const allPassengers = selectedLeg?.passengers.map(
    ({ firstName, lastName, reservationId }, key) => ({
      firstName,
      lastName,
      reservationId,
      index: key,
    })
  );
  const isRoomForDirectionArrow = useMediaQuery({
    minWidth: (currentFloor?.size?.x ?? 0) + 70,
  });

  useEffect(() => {
    if (containerRef.current && currentFloor?.size) {
      setCanvasReady(true);
    }
  }, [currentFloor?.size]);

  if (!currentFloor?.size?.x || !currentFloor?.size?.y || !floorPlanIcons) {
    return null;
  }

  return (
    <div className="relative self-center">
      <div
        ref={containerRef}
        className="cursor-pointer border border-neutral-light"
        style={{
          width: `${currentFloor.size.x}px`,
          height: `${currentFloor.size.y}px`,
        }}
      >
        {canvasReady && containerRef.current && (
          <VehicleLayoutCanvas
            container={containerRef.current}
            currentFloor={currentFloor}
            floorPlanIcons={floorPlanIcons}
            selectedReservationId={selectedReservationId}
            onSeatSelect={handleSeatSelect}
            onPassengerSeatClick={handlePassengerSeatClick}
            allPassengers={allPassengers}
          />
        )}
      </div>
      {isRoomForDirectionArrow && (
        <div className="absolute -right-16 top-10 flex -rotate-90 flex-col items-center">
          <Icons.arrow />
          <Typography variant="body1" className="rotate-180">
            <TransText i18nKey="front" />
          </Typography>
        </div>
      )}
    </div>
  );
};
